export const otaConnectWizard = {
  google: {
    lead: "Primeiro verificamos se a ficha do seu alojamento está completa: o Google não tem painel próprio e só mostra o que lhe enviarmos.",
    goConnect: "Continuar no Channex",
    nextIsChannex: "O último passo — escolher que quartos e tarifas o Google vê — faz-se no ecrã do Channex, que abrirá a seguir.",
    typeLabel: "Que tipo de alojamento é?",
    hotel: "Hotel",
    hotelHint: "Com vários quartos",
    vr: "Alojamento de férias",
    vrHint: "Uma casa ou apartamento inteiro",
    checking: "A verificar a ficha do alojamento…",
    ready: "Tudo pronto: o Google pode publicá-lo.",
    missing: "Falta 1 coisa antes de ligar | Faltam {count} coisas antes de ligar",
    canFix: "Parte disso já temos guardado e podemos enviar por si.",
    prepare: "Preparar a ficha",
    prepareFailed: "Não foi possível preparar a ficha.",
    checkFailed: "Não foi possível verificar a ficha.",
    cancelLabel: "Política de cancelamento",
    cancelFree: "Cancelamento gratuito",
    cancelNon: "Não reembolsável",
    bedrooms: "Quartos",
    beds: "Camas",
    bathrooms: "Casas de banho",
  },
  common: {
    close: "Fechar",
  },
  intro: {
    imageAlt: "Antes de conectar o Booking, tenha isto em mente",
    continue: "Entendi, continuar",
  },
  header: {
    edit: "Editar",
    connect: "Conectar",
    guidedStep: "Configuração guiada · etapa {current} de {total}",
  },
  steps: {
    connection: "Conexão",
    rooms: "Quartos",
    rates: "Tarifas",
    review: "Revisão",
    done: "Concluído",
  },
  fields: {
    hotel_id: { label: "ID do hotel", hint: "Você o encontra na extranet da OTA, no canto superior direito." },
    hotel_code: { label: "Código do hotel", hint: "O identificador da sua propriedade na OTA." },
    property_id: { label: "ID da propriedade", hint: "" },
    listing_id: { label: "ID do anúncio", hint: "" },
    property_code: { label: "Código da propriedade", hint: "" },
    username: { label: "Nome de usuário", hint: "Seu nome de usuário para acessar a extranet da OTA." },
    user: { label: "Nome de usuário", hint: "Seu nome de usuário para acessar a extranet da OTA." },
    password: { label: "Senha", hint: "Sua senha da extranet da OTA." },
    api_key: { label: "Chave de API", hint: "A OTA fornece a você." },
    agent_id: { label: "ID do agente", hint: "" },
  },
  step0: {
    lead: "Cole o identificador da sua propriedade no canal. Vamos verificá-lo na hora.",
    loadingChannel: "Carregando os requisitos do canal…",
    notAvailable: "Este canal ainda não está disponível via API guiada.",
    oauthText: "O {name} se conecta à sua conta por meio de login seguro. Ao clicar, abrimos o {name} em outra aba para você autorizar; quando voltar, a conexão aparece nos seus canais.",
    oauthConnect: "Conectar com {name}",
    oauthOpened: "Abrimos o {name} em outra aba. Autorize lá e a conexão aparecerá nos seus canais.",
    currencyLabel: "Moeda",
    currencyTooltip: "O canal a define para a sua propriedade. É preenchida automaticamente ao verificar a conexão; não pode ser editada.",
    currencyPlaceholder: "Preenchido ao verificar",
    currencyDetected: "Detectada automaticamente",
    currencyVerifyToDetect: "Verifique a conexão para detectá-la",
    verified: "Verificada",
    testConnection: "Testar conexão",
    testOk: "Conexão verificada. Continue para relacionar quartos e tarifas.",
    testFailedDefault: "Não foi possível verificar a conexão. Verifique o identificador.",
  },
  step1: {
    leadAirbnb: "Relacione cada anúncio do Airbnb com uma das suas unidades.",
    leadOther: "Relacione cada quarto do {channel} com uma unidade do seu anúncio.",
    listingChip: "Anúncio: {name}",
    noLimitChip: "Sem limite de contas ou propriedades",
    loadingRooms: "Carregando os quartos do canal…",
    noRooms: "Nenhum quarto encontrado para mapear.",
    dupUnitWarning: "«{unit}» está atribuída a mais de um quarto do {channel}. Cada quarto do canal deve ir para um quarto diferente seu: se salvar assim, o {channel} venderia todos pelo mesmo preço. Corrija abaixo antes de continuar.",
    searchPlaceholder: "Buscar…",
    noRoomMatch: "Nenhum quarto corresponde a «{query}».",
    copied: "Copiado",
    copyId: "Copiar ID: {id}",
    rateCountMeta: "{channel} · {count} tarifa(s)",
    edit: "Editar",
    disconnect: "Desconectar",
    unitSearchPlaceholder: "Busque sua unidade ou anúncio…",
    noMatch: "Nenhuma correspondência",
    cancel: "Cancelar",
  },
  step2: {
    lead: "A tarifa principal de cada quarto é preenchida automaticamente a partir da sua tarifa do {channel}. Se um quarto tiver várias tarifas, defina quanto % a mais (ou a menos) você cobrará em cada uma.",
    crossedFixed: "Uma tarifa foi relacionada a outro quarto, o que faria o {channel} vender pelo preço errado. A tarifa própria de cada quarto foi restaurada: revise-as antes de continuar. | {count} tarifas foram relacionadas a outro quarto, o que faria o {channel} vender pelo preço errado. A tarifa própria de cada quarto foi restaurada: revise-as antes de continuar.",
    noRates: "Nenhuma tarifa encontrada para mapear.",
    yourPct: "Seu % para este quarto",
    auto: "Automático",
    changePct: "Alterar %",
    multiRateAlert: "Este quarto tem várias tarifas. Defina qual porcentagem a mais (ou a menos) você cobrará dos seus hóspedes em cada uma caso reservem pelo {channel}.",
    minStayOnApply: "É salvo ao clicar em «Aplicar».",
    minStayMissing: "Sem estadia mínima própria: {channel} a vende com a mínima da tarifa principal",
    setMinStay: "Definir estadia mínima",
    nights: "{n} noite | {n} noites",
    minNights: "mín. {n} noite | mín. {n} noites",
    minInherited: "mín. da tarifa principal",
    ownPlanSummary: "preço e mínima próprios",
    minStayNotDerived: "A estadia mínima de {nights} não foi aplicada: «{rate}» é uma tarifa principal e usa a sua própria estadia mínima. Para que {channel} exija {nights} nesta tarifa, aplique um % em vez de escolhê-la.",
  },
  step3: {
    lead: "É isto que vamos conectar no {channel}. Revise e clique em Conectar.",
    channelCurrency: "Moeda do canal:",
    chargesNote: "Check-in/out e cobranças (limpeza, etc.) são obtidos das configurações da sua propriedade.",
  },
  done: {
    titleConnected: "{name} conectado!",
    titleUpdated: "{name} atualizado!",
    subActive: "O canal está ativo: já estamos sincronizando preços e disponibilidade.",
    subPaused: "O canal está conectado, mas pausado. Ative-o para começar a sincronizar preços e disponibilidade.",
    subUpdated: "O mapeamento do canal foi atualizado com sucesso.",
    notificationSent: "Notificação enviada",
    syncing: "Sincronizando…",
    paused: "Pausado",
    activateTitle: "Ativar canal",
    activateDesc: "Começa a enviar preços e disponibilidade para o {channel}.",
    activateBtn: "Ativar canal",
    activated: "Ativado",
    loadReservationsTitle: "Importar reservas futuras",
    loadReservationsDesc: "Traz para o WACheckin as reservas que você já tem no {channel}.",
    imported: "Importadas",
    extract: "Importar",
  },
  rates: {
    mainRate: "Tarifa principal",
    standardRate: "Tarifa Padrão",
  },
  rooms: {
    listingFallback: "Anúncio {id}",
    unitFallback: "unidade",
  },
  buttons: {
    back: "Voltar",
    saveChanges: "Salvar alterações",
    connect: "Conectar",
    finish: "Concluir",
    continue: "Continuar",
  },
  errors: {
    dupUnit: "A unidade «{unit}» está atribuída a mais de um quarto do {channel}. Cada quarto deve ir para uma unidade diferente.",
    crossedBlocked: "Há uma tarifa relacionada a outro quarto ({list}). Volte à etapa de tarifas e escolha a tarifa própria de cada quarto: se salvar assim, o {channel} venderia pelo preço errado. | Há {count} tarifas relacionadas a outro quarto ({list}). Volte à etapa de tarifas e escolha a tarifa própria de cada quarto: se salvar assim, o {channel} venderia pelo preço errado.",
    dupRate: "A tarifa «{rate}» está relacionada a mais de um quarto do {channel} ({rooms}). Cada quarto deve ter a sua própria tarifa: se salvar assim, venderiam pelo mesmo preço.",
    roomJoiner: " e ",
    dupRateFallback: "uma tarifa",
    dupUnitFallback: "esta unidade",
    needRate: "Relacione ao menos uma tarifa antes de conectar.",
    updateFailed: "Não foi possível atualizar a conexão.",
    createFailed: "Não foi possível criar a conexão.",
    unmapFailed: "Não foi possível desconectar o anúncio.",
    needAirbnbMap: "Relacione ao menos um anúncio com uma unidade.",
    unitNoChannexRate: "A unidade \"{unit}\" não tem nenhuma tarifa com um id do Channex.",
    airbnbSaveFailed: "Não foi possível salvar os mapeamentos do Airbnb.",
    actionFailed: "Não foi possível executar a ação.",
    oauthLinkFailed: "Não foi possível gerar o link de conexão.",
    testFailed: "Erro ao testar a conexão.",
    testNoVerify: "Este canal não requer verificação prévia.",
    rateCreateFailedNeedStandard: "Não foi possível criar a tarifa. Verifique se a unidade tem uma Tarifa Padrão.",
    rateCreateFailed: "Não foi possível criar a tarifa.",
    minStaySaveFailed: "«{rate}» foi escolhida, mas não foi possível salvar a estadia mínima de {nights}: continua com a que tinha.",
  },
};
